<template>
  <div>
    <div class="diff-container mb-2" v-html="diffHtml"></div>
  </div>
  <b-form-group description="">
      <form-switch
        v-model="showRemoved"
        @change="updateShowRemoved()"
      />
      <label>Display Removed Text</label>
  </b-form-group>
</template>


<script>
import { diffWords } from 'diff'
import DOMPurify from 'dompurify'
import FormSwitch from '../../generic/form-switch/form-switch.vue'

export default {
  name: 'DiffViewer',
  components: {
    FormSwitch
  },
  props: {
    originalTemplate: {
      type: String,
      required: true
    },
    correctedTemplate: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showRemoved: false
    }
  },
  computed: {
    diffHtml() {
      const diff = diffWords(this.originalTemplate, this.correctedTemplate)
      const html = diff
        .map(part => {
          if (part.added) {
            return `<span style="background-color: #e6ffed; color: #2e7d32; text-decoration: none; padding: 0 2px;">${part.value}</span>`
          } else if (part.removed) {
            if (this.showRemoved) {
              return `<span style="background-color: #ffebee; color: #d32f2f; text-decoration: line-through; padding: 0 2px;">${part.value}</span>`
            } else {
              return ''
            }
          } else {
            return part.value
          }
        })
        .join('')
      return DOMPurify.sanitize(html)
    }
  },
  methods: {
    updateShowRemoved() {
      console.log('Show removed updated:', this.showRemoved)
    }
  }
}
</script>

<style scoped>
.diff-container {
  border-bottom: 1px solid #ccc;
}
</style>